import { B2C } from "./B2C";

export const TrustpilotReview = () => {
  return <B2C />;
};
